import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/common/jwt.service";
import { API_URL } from "@/common/config";

const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = API_URL;
  },

  setHeader() {
    Vue.axios.defaults.headers.common[
      "Authorization"
    ] = `Token ${JwtService.getToken()}`;
  },

  query(resource, params) {
    return Vue.axios.get(resource, params).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },

  get(resource, slug = "") {
    return Vue.axios.get(`${resource}/${slug}`).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },

  post(resource, params) {
    return Vue.axios.post(`${resource}`, params);
  },

  update(resource, slug, params) {
    return Vue.axios.put(`${resource}/${slug}`, params);
  },

  upload(asset) {
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }

    let formData = new FormData();
    formData.append('asset', asset.file);
    formData.append('description', asset.description);

    return Vue.axios.post(`assets/category/${asset.category}`, formData, config);
  },

  put(resource, params) {
    return Vue.axios.put(`${resource}`, params);
  },

  delete(resource, itemId) {
    return Vue.axios.delete(`${resource}/${itemId}`).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  }
};

export default ApiService;

export const AssetsService = {
  get(slug) {
    return ApiService.get("assets", slug);
  },
  update(slug, params) {
    return ApiService.update("assets", slug, { asset: params });
  },
  upload(asset) {
    return ApiService.upload(asset);
  },
  delete(assetId) {
    return ApiService.delete("assets", assetId);
  }
};

export const PagesService = {
  query(type, params) {
    return ApiService.query("pages", {
      params: params
    });
  },
  get(slug) {
    return ApiService.get("pages", slug);
  },
  create(params) {
    return ApiService.post("pages", { page: params });
  },
  update(slug, params) {
    return ApiService.update("pages", slug, { page: params });
  },
  destroy(slug) {
    return ApiService.delete("pages", slug);
  }
};

export const UsersService = {
  query(type, params) {
    return ApiService.query("user", {
      params: params
    });
  },
  get(slug) {
    return ApiService.get(slug);
  },
  create(params) {
    return ApiService.post("users", { user: params });
  },
  update(params) {
    return ApiService.update("user", '', { 
      user: params 
    });
  },
  post(slug, params) {
    return ApiService.post(slug, { 
      user: params 
    });
  },
  delete(userId) {
    return ApiService.delete("user", userId);
  }
};

export const ConfigService = {
  query(type, params) {
    return ApiService.query("config", {
      params: params
    });
  },
  get(slug) {
    return ApiService.get("config", slug);
  },
  create(configItems) {
    return ApiService.post("config", configItems);
  },
  update(params) {
    return ApiService.update("config", '', { config: params });
  },
  destroy(slug) {
    return ApiService.delete(`config/${slug}`);
  }
};

export const NavItemsService = {
  query(type, params) {
    return ApiService.query("navigation", {
      params: params
    });
  },
  get(slug) {
    return ApiService.get("navigation", slug);
  },
  create(params) {
    return ApiService.post("navigation", { navigation: params });
  },
  update(params) {
    return ApiService.update("navigation", '', { navigation: params });
  },
  destroy(slug) {
    return ApiService.delete(`navigation/${slug}`);
  }
};
